import { FC } from "react";
import { ShareIssueModel } from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { VBox } from "../../components-v2/Box";
import NewShareType from "./NewShareType";
import ShareIssueForShareType from "./ShareIssueForShareType";
import { MCheckboxGroup } from "../../components-v2/Checkbox";

import { useTranslation } from "../../stores/RootStoreContext";

const SelectShareTypesForIssue: FC<{ model: ShareIssueModel }> = observer(({ model }) => {
  const { t } = useTranslation();
  return (
    <>
      <VBox>
        <div>{t("decisions.increaseShareCapitalAgainstCash.selectShareType")}</div>
        <MCheckboxGroup
          model={model.selectedShareTypes}
          onChange={(_event, option) => model.toggleSelectedShareType(option)}
          disabled={model.isProjectLocked}
        />
        <NewShareType model={model} />
      </VBox>
      {model.selectedShareTypes.selected.map((m) => (
        <ShareIssueForShareType
          model={m.model}
          isLocked={model.isProjectLocked}
          key={m.sharetypeId}
        />
      ))}
    </>
  );
});

export default SelectShareTypesForIssue;
